import * as XLSX from 'xlsx';

/**
 * Export data to Excel file (.xlsx format) using the xlsx library
 * @param data - Array of row data to export
 * @param columns - Array of column definitions with field and headerName properties
 * @param fileName - Name of the file (without extension)
 * @param sheetName - Name of the worksheet
 * @example
 * exportDataToExcel(
 *   userData,
 *   USER_LIST_COLUMNS,
 *   'User_List_All_2025-12-16',
 *   'Users - All'
 * );
 */
export const exportDataToExcel = (
  data: Record<string, any>[],
  columns: Array<{ field: string; headerName?: string; cellRenderer?: any }>,
  fileName: string,
  sheetName: string = 'Sheet1'
): void => {
  try {
    // Prepare data for Excel with proper headers and formatting
    const exportData = data.map((row: any) => {
      const exportRow: any = {};
      columns.forEach((col: any) => {
        let cellValue = row[col.field] || '';
        
        // If column has cellRenderer, apply it (e.g., for date formatting)
        if (col.cellRenderer && typeof col.cellRenderer === 'function') {
          cellValue = col.cellRenderer({ value: row[col.field] });
        }
        
        exportRow[col.headerName || col.field] = cellValue;
      });
      return exportRow;
    });

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(exportData);

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    // Generate file name with .xlsx extension
    const fullFileName = fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`;

    // Download file
    XLSX.writeFile(workbook, fullFileName);

    console.log('Export completed successfully:', fullFileName);
  } catch (error: any) {
    console.error('Export failed:', error);
    throw new Error(`Export failed: ${error.message}`);
  }
};